import React from 'react';
import ReservationRuleGroups from '../ReservationRuleGroups';

const AssignReservationRuleDrawerContent = ({
  groups = [],
  rulesByType = {},
  isRulesLoading = false,
  onGroupsChange,
  selectedCount = 0,
  entityNoun = 'toys',
}) => (
  <>
    <div className="font-size-14 mb-16">
      Applying to <strong>{selectedCount}</strong> selected {entityNoun}.
    </div>

    <ReservationRuleGroups
      groups={groups}
      rulesByType={rulesByType}
      isRulesLoading={isRulesLoading}
      onGroupsChange={onGroupsChange}
    />
  </>
);

export default AssignReservationRuleDrawerContent;
